// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/bidding_common_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/bidding_common_model.proto.
 */
export const file_bffuser_v1_bidding_common_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * まとめて承認 (docs/specs/bidding/spot-bidding.md AC-BSP-118) の対象 1 件。
 * internalapi.v1.BulkApprovalTarget の mirror。
 *
 * @generated from message bffuser.v1.BiddingBulkApprovalTarget
 */
export type BiddingBulkApprovalTarget = Message<"bffuser.v1.BiddingBulkApprovalTarget"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 楽観ロック基準値 (= 画面が読んだ案件の updated_at)。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.BiddingBulkApprovalTarget.
 * Use `create(BiddingBulkApprovalTargetSchema)` to create a new message.
 */
export const BiddingBulkApprovalTargetSchema: GenMessage<BiddingBulkApprovalTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_common_model, 0);

/**
 * まとめて承認で承認した案件の結果 (AC-BSP-118)。 internalapi.v1.BulkApprovalApproved の mirror。
 *
 * @generated from message bffuser.v1.BiddingBulkApprovalApproved
 */
export type BiddingBulkApprovalApproved = Message<"bffuser.v1.BiddingBulkApprovalApproved"> & {
  /**
   * 承認後の承認状態。 多段階承認の途中段なら承認待ち、 最終段なら承認済。
   *
   * @generated from field: bffuser.v1.BiddingApprovalState approval_state = 1;
   */
  approvalState: BiddingApprovalState;
};

/**
 * Describes the message bffuser.v1.BiddingBulkApprovalApproved.
 * Use `create(BiddingBulkApprovalApprovedSchema)` to create a new message.
 */
export const BiddingBulkApprovalApprovedSchema: GenMessage<BiddingBulkApprovalApproved> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_common_model, 1);

/**
 * 入札中の札の一括取下 (docs/specs/bidding/spot-bidding.md AC-BSP-116) の対象 1 件。
 * internalapi.v1.BulkWithdrawTarget の mirror。
 *
 * @generated from message bffuser.v1.BiddingBulkWithdrawTarget
 */
export type BiddingBulkWithdrawTarget = Message<"bffuser.v1.BiddingBulkWithdrawTarget"> & {
  /**
   * 通常入札は札 (SpotBid) の id、 ブロック入札はグループの id。
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 楽観ロック基準値 (= 画面が読んだ時点の、 札が属する申請セット〈ブロック入札はグループ〉の updated_at)。
   *
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.BiddingBulkWithdrawTarget.
 * Use `create(BiddingBulkWithdrawTargetSchema)` to create a new message.
 */
export const BiddingBulkWithdrawTargetSchema: GenMessage<BiddingBulkWithdrawTarget> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_common_model, 2);

/**
 * 一括取下で取下を受け付けた札の結果 (AC-BSP-116)。 internalapi.v1.BulkWithdrawAccepted の mirror。
 * 取消の成立ではなく、 札は取下処理中になる。
 *
 * @generated from message bffuser.v1.BiddingBulkWithdrawAccepted
 */
export type BiddingBulkWithdrawAccepted = Message<"bffuser.v1.BiddingBulkWithdrawAccepted"> & {
};

/**
 * Describes the message bffuser.v1.BiddingBulkWithdrawAccepted.
 * Use `create(BiddingBulkWithdrawAcceptedSchema)` to create a new message.
 */
export const BiddingBulkWithdrawAcceptedSchema: GenMessage<BiddingBulkWithdrawAccepted> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_common_model, 3);

/**
 * @generated from message bffuser.v1.BiddingBulkWithdrawFailure
 */
export type BiddingBulkWithdrawFailure = Message<"bffuser.v1.BiddingBulkWithdrawFailure"> & {
  /**
   * @generated from field: bffuser.v1.BiddingBulkWithdrawFailureReason reason = 1;
   */
  reason: BiddingBulkWithdrawFailureReason;
};

/**
 * Describes the message bffuser.v1.BiddingBulkWithdrawFailure.
 * Use `create(BiddingBulkWithdrawFailureSchema)` to create a new message.
 */
export const BiddingBulkWithdrawFailureSchema: GenMessage<BiddingBulkWithdrawFailure> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_common_model, 4);

/**
 * 承認申請の時点で承認フロー設定 (スポット入札) から写した、 1 エリア・1 承認段階の
 * 承認者 (BFF mirror、 backend `internalapi.v1.BidApprovalStageApprovers` と 1:1、
 * docs/specs/bidding/spot-bidding.md AC-BSP-098)。
 *
 * @generated from message bffuser.v1.BiddingApprovalStageApprovers
 */
export type BiddingApprovalStageApprovers = Message<"bffuser.v1.BiddingApprovalStageApprovers"> & {
  /**
   * 承認段階 (1 始まり)。
   *
   * @generated from field: int32 stage_order = 1;
   */
  stageOrder: number;

  /**
   * 写し元の承認フロー設定のエリア。
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * 承認者の eauth member_id (承認フロー設定の並び順)。 1 人以上。
   * GetCurrentSession の member_id と突き合わせて承認者非該当を判定する。
   *
   * @generated from field: repeated string approver_member_ids = 3;
   */
  approverMemberIds: string[];
};

/**
 * Describes the message bffuser.v1.BiddingApprovalStageApprovers.
 * Use `create(BiddingApprovalStageApproversSchema)` to create a new message.
 */
export const BiddingApprovalStageApproversSchema: GenMessage<BiddingApprovalStageApprovers> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_bidding_common_model, 5);

/**
 * 承認モード (BFF mirror、 backend `internalapi.v1.ApprovalMode` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingApprovalMode
 */
export enum BiddingApprovalMode {
  /**
   * @generated from enum value: BIDDING_APPROVAL_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_APPROVAL_MODE_APPROVAL = 1;
   */
  APPROVAL = 1,

  /**
   * @generated from enum value: BIDDING_APPROVAL_MODE_AUTO = 2;
   */
  AUTO = 2,

  /**
   * @generated from enum value: BIDDING_APPROVAL_MODE_NO_APPROVAL = 3;
   */
  NO_APPROVAL = 3,
}

/**
 * Describes the enum bffuser.v1.BiddingApprovalMode.
 */
export const BiddingApprovalModeSchema: GenEnum<BiddingApprovalMode> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 0);

/**
 * 承認状態 (BFF mirror、 backend `internalapi.v1.ApprovalState` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingApprovalState
 */
export enum BiddingApprovalState {
  /**
   * @generated from enum value: BIDDING_APPROVAL_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_APPROVAL_STATE_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: BIDDING_APPROVAL_STATE_PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: BIDDING_APPROVAL_STATE_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: BIDDING_APPROVAL_STATE_REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * @generated from enum value: BIDDING_APPROVAL_STATE_SUBMITTED = 5;
   */
  SUBMITTED = 5,

  /**
   * @generated from enum value: BIDDING_APPROVAL_STATE_FAILED = 6;
   */
  FAILED = 6,

  /**
   * @generated from enum value: BIDDING_APPROVAL_STATE_CANCELLED = 7;
   */
  CANCELLED = 7,
}

/**
 * Describes the enum bffuser.v1.BiddingApprovalState.
 */
export const BiddingApprovalStateSchema: GenEnum<BiddingApprovalState> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 1);

/**
 * スポット入札 1 行の状態 (BFF mirror、 backend `SpotBidStatus` と 1:1)。
 * 約定結果に加えて札 1 枚単位の取下状態 (AC-BSP-057 / AC-BSP-057b) も運ぶ。
 *
 * @generated from enum bffuser.v1.BiddingSpotBidStatus
 */
export enum BiddingSpotBidStatus {
  /**
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_MATCHED = 2;
   */
  MATCHED = 2,

  /**
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_UNMATCHED = 3;
   */
  UNMATCHED = 3,

  /**
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * 失効 (= 締切までに JEPX へ送信できなかった。 約定対象外。 AC-BSP-011)。
   *
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_EXPIRED = 5;
   */
  EXPIRED = 5,

  /**
   * 取消 (= 取下成立)。
   *
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_CANCELLED = 6;
   */
  CANCELLED = 6,

  /**
   * 取下処理中 (= JEPX 取消 API 呼び出し中 / リトライ中)。
   * ステータス列の表示は「入札中」 のまま維持する (AC-BSP-057b)。
   *
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_WITHDRAWING = 7;
   */
  WITHDRAWING = 7,

  /**
   * 取下失敗 (= 入札締切到達で確定)。
   *
   * @generated from enum value: BIDDING_SPOT_BID_STATUS_WITHDRAW_FAILED = 8;
   */
  WITHDRAW_FAILED = 8,
}

/**
 * Describes the enum bffuser.v1.BiddingSpotBidStatus.
 */
export const BiddingSpotBidStatusSchema: GenEnum<BiddingSpotBidStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 2);

/**
 * 時間前注文の状態 (BFF mirror、 backend `IntradayOrderStatus` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingIntradayOrderStatus
 */
export enum BiddingIntradayOrderStatus {
  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_PLACED = 4;
   */
  PLACED = 4,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_PARTIAL_MATCHED = 5;
   */
  PARTIAL_MATCHED = 5,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_ALL_MATCHED = 6;
   */
  ALL_MATCHED = 6,

  /**
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_CANCELLED = 7;
   */
  CANCELLED = 7,

  /**
   * 送信失敗。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_FAILED = 8;
   */
  FAILED = 8,

  /**
   * 未約定 (= GC 到達時点で板に並んでいた〈約定累計ゼロ〉。 AC-BIN-019 / 036)。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_UNMATCHED = 9;
   */
  UNMATCHED = 9,

  /**
   * 失効 (= GC 到達時点で JEPX の板に一度も並べなかった。 AC-BIN-019 / 036)。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_EXPIRED = 10;
   */
  EXPIRED = 10,

  /**
   * 自動取消 (= JEPX の板に並んでいた札が、 約定ゼロのまま自動取消時刻に達して取り下げられた。 AC-BIN-017 / 035)。
   *
   * @generated from enum value: BIDDING_INTRADAY_ORDER_STATUS_AUTO_CANCELLED = 11;
   */
  AUTO_CANCELLED = 11,
}

/**
 * Describes the enum bffuser.v1.BiddingIntradayOrderStatus.
 */
export const BiddingIntradayOrderStatusSchema: GenEnum<BiddingIntradayOrderStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 3);

/**
 * 外部市場ゲートウェイ送信 lifecycle (BFF mirror、 backend `BidSendStatus` と 1:1)。
 * 承認軸 (BiddingApprovalState) / 約定軸 (BiddingSpotBidStatus 等) と直交。
 *
 * @generated from enum bffuser.v1.BiddingBidSendStatus
 */
export enum BiddingBidSendStatus {
  /**
   * @generated from enum value: BIDDING_BID_SEND_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 送信待ち。
   *
   * @generated from enum value: BIDDING_BID_SEND_STATUS_ENQUEUED = 1;
   */
  ENQUEUED = 1,

  /**
   * 送信中。
   *
   * @generated from enum value: BIDDING_BID_SEND_STATUS_SENDING = 2;
   */
  SENDING = 2,

  /**
   * 提出済 (= JEPX 受理)。
   *
   * @generated from enum value: BIDDING_BID_SEND_STATUS_SENT = 3;
   */
  SENT = 3,

  /**
   * 送信失敗 (一時的障害 = 再送中)。
   *
   * @generated from enum value: BIDDING_BID_SEND_STATUS_SEND_FAILED = 4;
   */
  SEND_FAILED = 4,

  /**
   * 送信失敗 (確定 = gate close / 入札時間制限超過等で再送しない)。
   *
   * @generated from enum value: BIDDING_BID_SEND_STATUS_SEND_FAILED_FINAL = 5;
   */
  SEND_FAILED_FINAL = 5,

  /**
   * 予約中 (= 市場開場前に提出され、 開場時刻まで送信を待っている状態)。
   *
   * @generated from enum value: BIDDING_BID_SEND_STATUS_RESERVED = 6;
   */
  RESERVED = 6,

  /**
   * 取消 (= 開場前の注文が取下され、 送らずに終わった状態)。
   *
   * @generated from enum value: BIDDING_BID_SEND_STATUS_CANCELED = 7;
   */
  CANCELED = 7,
}

/**
 * Describes the enum bffuser.v1.BiddingBidSendStatus.
 */
export const BiddingBidSendStatusSchema: GenEnum<BiddingBidSendStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 4);

/**
 * 送信失敗の理由カテゴリ (BFF mirror、 backend `BidSendErrorCategory` と 1:1)。
 * send_status が失敗系のときだけ意味を持つ。
 *
 * @generated from enum bffuser.v1.BiddingBidSendErrorCategory
 */
export enum BiddingBidSendErrorCategory {
  /**
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 受渡契約コード未設定。
   *
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_DELIVERY_CONTRACT_CODE_MISSING = 1;
   */
  DELIVERY_CONTRACT_CODE_MISSING = 1,

  /**
   * 締切超過 (= 入札時間制限超過 / gate close)。
   *
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_GATE_CLOSED = 2;
   */
  GATE_CLOSED = 2,

  /**
   * eSLJ バリデーション拒否 (確定失敗)。
   *
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_VALIDATION_REJECTED = 3;
   */
  VALIDATION_REJECTED = 3,

  /**
   * 通信・一時障害 (再送中)。
   *
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_TRANSIENT = 4;
   */
  TRANSIENT = 4,

  /**
   * 送信対象が存在しない。
   *
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_TARGET_NOT_FOUND = 5;
   */
  TARGET_NOT_FOUND = 5,

  /**
   * その他 (未分類)。
   *
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_OTHER = 6;
   */
  OTHER = 6,

  /**
   * 内部検証違反 (入札制限)。
   *
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_INTERNAL_VALIDATION_VIOLATION = 7;
   */
  INTERNAL_VALIDATION_VIOLATION = 7,

  /**
   * 内部検証違反 (承認モード)。 画面の分類名は入札制限の場合と同じ。
   *
   * @generated from enum value: BIDDING_BID_SEND_ERROR_CATEGORY_INTERNAL_VALIDATION_VIOLATION_APPROVAL_MODE = 8;
   */
  INTERNAL_VALIDATION_VIOLATION_APPROVAL_MODE = 8,
}

/**
 * Describes the enum bffuser.v1.BiddingBidSendErrorCategory.
 */
export const BiddingBidSendErrorCategorySchema: GenEnum<BiddingBidSendErrorCategory> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 5);

/**
 * JEPX 市場種別 (BFF mirror、 backend `BidMarket` と 1:1)。
 *
 * @generated from enum bffuser.v1.BiddingBidMarket
 */
export enum BiddingBidMarket {
  /**
   * @generated from enum value: BIDDING_BID_MARKET_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BIDDING_BID_MARKET_SPOT = 1;
   */
  SPOT = 1,

  /**
   * @generated from enum value: BIDDING_BID_MARKET_INTRADAY = 2;
   */
  INTRADAY = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingBidMarket.
 */
export const BiddingBidMarketSchema: GenEnum<BiddingBidMarket> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 6);

/**
 * スポット / 時間前 lifecycle の action 種別 (BFF mirror、 backend `BidLifecycleAction` と 1:1)。
 * spot service と intraday service の TransitionState RPC で共通使用。
 * service 別の action 有効性:
 *   - spot: REQUEST / APPROVE / REJECT / CANCEL / SUBMIT / REOPEN が有効。
 *     WITHDRAW はオークション方式で提出後撤回不可のため InvalidArgument。
 *   - block: REQUEST / APPROVE / REJECT / CANCEL / SUBMIT / REOPEN に加え、 WITHDRAW は
 *     予約中 (受付開始前に提出した札、 AC-BSP-092) の予約取消だけ有効。 予約中以外・入札締切後は
 *     FailedPrecondition (InvalidArgument ではない)。
 *   - intraday: WITHDRAW まで有効 (= ザラバ方式で板からの取下が可能)。 REOPEN も
 *     有効 (差戻し後再編集、 AC-BIN-049)。 最終段を完了させた APPROVE は同じ呼び出しで
 *     JEPX 提出まで進み、 戻り値の承認状態は提出済になる (AC-BIN-095)。 途中の段の APPROVE は
 *     承認申請中のまま返る。
 *   - RETURN_TO_DRAFT は block と intraday で有効 (送信中の札を下書きに戻す、 AC-BSP-117 /
 *     AC-BIN-115)。 spot はまだ受け付けず InvalidArgument (#11944 の回答待ち)。
 *
 * @generated from enum bffuser.v1.BiddingLifecycleAction
 */
export enum BiddingLifecycleAction {
  /**
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 承認申請 (= 下書き → 承認申請中)。 申請者操作。
   *
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_REQUEST = 1;
   */
  REQUEST = 1,

  /**
   * 承認 (= 承認申請中の 1 段を承認。 多段階承認では最終段の承認でだけ承認済になり、 途中は承認申請中のまま)。 承認者操作。
   *
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_APPROVE = 2;
   */
  APPROVE = 2,

  /**
   * 差戻し (= 承認申請中 → 差戻し)。 承認者操作、 reason 必須。
   *
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_REJECT = 3;
   */
  REJECT = 3,

  /**
   * 申請取消 (= 承認申請中 → 下書きに戻す)。 申請者操作。
   *
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_CANCEL = 4;
   */
  CANCEL = 4,

  /**
   * JEPX 提出 (= 承認済 → 提出済 / 板に出している)。
   *
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_SUBMIT = 5;
   */
  SUBMIT = 5,

  /**
   * 取下 (= 板に出している → 取下)。 intraday で有効、 spot では InvalidArgument。
   * block は予約中の予約取消だけ有効 (それ以外は FailedPrecondition)。
   *
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_WITHDRAW = 6;
   */
  WITHDRAW = 6,

  /**
   * 差戻し後再編集 (= 差戻し → 下書きに戻す)。 申請者操作。 spot / block (AC-056)・
   * intraday (AC-BIN-049) いずれも有効。 差戻し理由・日時は保持表示する。
   *
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_REOPEN = 7;
   */
  REOPEN = 7,

  /**
   * 下書きに戻す (= 送信中 → 下書き)。 申請者操作。 送り直しを止め、 同じ札を承認ステータス N/A の
   * 下書きに戻す (AC-BSP-117 / AC-BIN-115)。 ブロックはグループ単位。
   *
   * @generated from enum value: BIDDING_LIFECYCLE_ACTION_RETURN_TO_DRAFT = 8;
   */
  RETURN_TO_DRAFT = 8,
}

/**
 * Describes the enum bffuser.v1.BiddingLifecycleAction.
 */
export const BiddingLifecycleActionSchema: GenEnum<BiddingLifecycleAction> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 7);

/**
 * まとめて承認で承認しなかった案件の理由 (AC-BSP-118)。
 * internalapi.v1.BidBulkApprovalFailureReason の wire 値 mirror。
 *
 * @generated from enum bffuser.v1.BiddingBulkApprovalFailureReason
 */
export enum BiddingBulkApprovalFailureReason {
  /**
   * @generated from enum value: BIDDING_BULK_APPROVAL_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 入札制限等の再検証で止まった (AC-BSP-097)。 案件は承認待ちのまま。
   *
   * @generated from enum value: BIDDING_BULK_APPROVAL_FAILURE_REASON_BID_LIMIT_VIOLATION = 1;
   */
  BID_LIMIT_VIOLATION = 1,

  /**
   * 他のユーザーが先に承認・差戻しした。
   *
   * @generated from enum value: BIDDING_BULK_APPROVAL_FAILURE_REASON_UPDATED_BY_OTHER = 2;
   */
  UPDATED_BY_OTHER = 2,

  /**
   * 申請取消された、 または削除されていた。
   *
   * @generated from enum value: BIDDING_BULK_APPROVAL_FAILURE_REASON_CANCELED_OR_DELETED = 3;
   */
  CANCELED_OR_DELETED = 3,

  /**
   * 入札締切を過ぎていた (通常入札・ブロック入札とも)。
   *
   * @generated from enum value: BIDDING_BULK_APPROVAL_FAILURE_REASON_GATE_CLOSURE = 4;
   */
  GATE_CLOSURE = 4,

  /**
   * 上記以外の業務上の理由。
   *
   * @generated from enum value: BIDDING_BULK_APPROVAL_FAILURE_REASON_OTHER = 5;
   */
  OTHER = 5,
}

/**
 * Describes the enum bffuser.v1.BiddingBulkApprovalFailureReason.
 */
export const BiddingBulkApprovalFailureReasonSchema: GenEnum<BiddingBulkApprovalFailureReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 8);

/**
 * 一括取下で取下を受け付けなかった札の理由 (AC-BSP-116)。
 * internalapi.v1.BidBulkWithdrawFailureReason の wire 値 mirror。
 *
 * @generated from enum bffuser.v1.BiddingBulkWithdrawFailureReason
 */
export enum BiddingBulkWithdrawFailureReason {
  /**
   * @generated from enum value: BIDDING_BULK_WITHDRAW_FAILURE_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 画面を開いた後にほかの操作で申請セット〈ブロック入札はグループ〉が更新されていたが、 札の状態は進んでおらず
   * 取下できる (内容だけが先に更新されていた。 AC-BSP-124)。 状態も進んでいた札は NOT_WITHDRAWABLE (AC-BSP-116)。
   *
   * @generated from enum value: BIDDING_BULK_WITHDRAW_FAILURE_REASON_UPDATED_BY_OTHER = 1;
   */
  UPDATED_BY_OTHER = 1,

  /**
   * 取下できない状態の札 (承認済・送信前・取下処理中・取消済・約定後・確定済ワークフロー経由 等。 AC-BSP-058)。
   * 画面を開いた後に状態が進んでいた札は、 申請セットの更新日時が変わっていてもこれにする (AC-BSP-116)。
   *
   * @generated from enum value: BIDDING_BULK_WITHDRAW_FAILURE_REASON_NOT_WITHDRAWABLE = 2;
   */
  NOT_WITHDRAWABLE = 2,

  /**
   * 入札締切を過ぎていた (AC-BSP-057c)。
   *
   * @generated from enum value: BIDDING_BULK_WITHDRAW_FAILURE_REASON_GATE_CLOSURE = 3;
   */
  GATE_CLOSURE = 3,

  /**
   * 札が無い。
   *
   * @generated from enum value: BIDDING_BULK_WITHDRAW_FAILURE_REASON_NOT_FOUND = 4;
   */
  NOT_FOUND = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingBulkWithdrawFailureReason.
 */
export const BiddingBulkWithdrawFailureReasonSchema: GenEnum<BiddingBulkWithdrawFailureReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 9);

/**
 * 入札 CSV 取込の行ステータス (BFF mirror、 backend `BidCsvRowStatus` と 1:1)。
 * 入札 CSV は既存札との突合を行わず全行を「新規」として扱うため CREATED / ERROR の
 * 2 値のみ (docs/specs/bidding/spot-bid-normal-csv-import.md スコープ内)。
 *
 * @generated from enum bffuser.v1.BiddingCsvRowStatus
 */
export enum BiddingCsvRowStatus {
  /**
   * @generated from enum value: BIDDING_CSV_ROW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 新規 (= 取込対象)。
   *
   * @generated from enum value: BIDDING_CSV_ROW_STATUS_CREATED = 1;
   */
  CREATED = 1,

  /**
   * エラー (= 取込対象外)。 1 件でもあれば確定 API は全体拒否。
   *
   * @generated from enum value: BIDDING_CSV_ROW_STATUS_ERROR = 2;
   */
  ERROR = 2,
}

/**
 * Describes the enum bffuser.v1.BiddingCsvRowStatus.
 */
export const BiddingCsvRowStatusSchema: GenEnum<BiddingCsvRowStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 10);

/**
 * 後から JEPX にあったと分かって札の状態を直した結果 (AC-BSP-117)。 申請セット (ブロックはグループ) ごとに持つ。
 *
 * @generated from enum bffuser.v1.BiddingJepxReconcileOutcome
 */
export enum BiddingJepxReconcileOutcome {
  /**
   * @generated from enum value: BIDDING_JEPX_RECONCILE_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 入札締切前に分かり、 入札中に戻した。
   *
   * @generated from enum value: BIDDING_JEPX_RECONCILE_OUTCOME_BACK_TO_BIDDING = 1;
   */
  BACK_TO_BIDDING = 1,

  /**
   * 入札締切後に分かり、 約定待ちにした。
   *
   * @generated from enum value: BIDDING_JEPX_RECONCILE_OUTCOME_TO_AWAITING_MATCH = 2;
   */
  TO_AWAITING_MATCH = 2,

  /**
   * 出し直した札と合わせて、 同じ札が JEPX に 2 本出ている。
   *
   * @generated from enum value: BIDDING_JEPX_RECONCILE_OUTCOME_DUPLICATE_ON_JEPX = 3;
   */
  DUPLICATE_ON_JEPX = 3,

  /**
   * 入札制限の再検証で失効にした札が入札締切前に JEPX に見つかり、 システムが取消を送った。
   *
   * @generated from enum value: BIDDING_JEPX_RECONCILE_OUTCOME_WITHDRAW_SENT = 4;
   */
  WITHDRAW_SENT = 4,
}

/**
 * Describes the enum bffuser.v1.BiddingJepxReconcileOutcome.
 */
export const BiddingJepxReconcileOutcomeSchema: GenEnum<BiddingJepxReconcileOutcome> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_bidding_common_model, 11);

